import * as React from 'react';
import { FunctionComponent } from 'react';

import { Box, Stepper } from '@mui/material';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export interface HorizontalLinearStep {
  stepTitle: string;
  component: any;
}

export interface HorizontalLinearStepperProps {
  steps: HorizontalLinearStep[];
  activeStep: any;
}

export const HorizontalLinearStepper: FunctionComponent<HorizontalLinearStepperProps> = 
({steps, activeStep}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // sm = mobile

  return (<>
        <Stepper activeStep={activeStep} style={{marginTop: "10px", marginBottom: "10px"}} alternativeLabel={isMobile}>
          {steps.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: React.ReactNode;
            } = {};
            return (
              <Step key={label.stepTitle} {...stepProps}>
                <StepLabel {...labelProps} >{label.stepTitle}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <React.Fragment>
          <br/>
          <Box>
            {steps[activeStep].component}
          </Box>
        </React.Fragment></>
  );
}
export default HorizontalLinearStepper;